import { parseNbaEventPayload } from '@c360/shared';
import type { SportEvent } from '../../types/SportEventTypes';
import { makeBaseSportEvent } from '../shared';

/**
 * Parse an NBA SES event into the normalized SportEvent shape. The payload
 * branching lives in @c360/shared (parseNbaEventPayload), so the business-api
 * MCP server files events the same way. Returns null if no basketball-shaped
 * branch matches — the registry will then try other modules.
 */
export function parseNbaEvent(rawEvent: any): SportEvent | null {
  const payload = parseNbaEventPayload(rawEvent);
  if (!payload) return null;
  const base = makeBaseSportEvent(rawEvent);
  base.payload = payload;
  return base as SportEvent;
}
